/* eslint-disable import/prefer-default-export */
export const COURSE_UNIT_LIST = `
query($courseId: Int!, $type: String) {
  chineseCourseUnitList(courseId: $courseId, type: $type) {
    wrongNumber
    list{
      id
      name
      status
      progress
      isExperience
    }
  }
}`;

export const COURSE_MODULE_LIST = `
query($unitId: Int!) {
  chineseCourseModuleList(unitId: $unitId) {
    name
    modeList {
      id
      name
      isFinished
      isCompleted
    }
  }
}`;

export const COURSE_DATA = `
query($modelId: Int, $type: String, $courseId: Int, $unitId: Int, $mode: String, $examType: String, $examMode: String, $projectCode: String){
  chineseCourseData(modelId: $modelId, type: $type, courseId: $courseId, unitId: $unitId, mode: $mode, examType: $examType, examMode: $examMode, projectCode: $projectCode){
    id
    type
    status
    navigation
    title
    subtitle
    description
    isBacktrack
    message
    playTimes
    quizzes{
      id
      code
      mode
      ... on ChineseCourseQuizQHLJ {
        image
        text
        explain
        fix {
          word
          tag
        }
        parse {
          audio
          text
        }
      }
      ... on ChineseCourseQuizDX {
        answer
        answerIndex
        question
        options
        parse {
          audio
          text
        }
      }
      ... on ChineseCourseQuizBQWZ {
        article
        extras
        parts {
          id
          answer
          parse {
            audio
            text
          }
        }
        parse {
          audio
          text
        }
      }
      ... on ChineseCourseQuizMED {
        duration
        items {
          id
          duration
          text
          explain
          audio
          image
        }
      }
      ... on ChineseCourseQuizKY {
        text
        audio
        beep
        image
        explain
      }
      ... on ChineseCourseQuizJXZH {
        question
        answer
        extras
        parse {
          audio
          text
        }
      }
      ... on ChineseCourseQuizTYLJ {
        text
        explain
        answer
        audio
        extras
      }
      ... on ChineseCourseQuizWK {
        video
        poster
        videoDone
        quizzes {
          question
          options
          answer
          type
          time
        }
      }
      ... on ChineseCourseQuizCHXZ {
        text
        explain
        audio
        options
        answer
        gameId
      }
      ... on ChineseCourseQuizDCTX {
        text
        explain
        audio
        gameId
      }
      ... on ChineseCourseQuizSK {
        text
        explain
        phonetic
        audio
        exampleSentence
        exampleExplain
        gameId
      }
      ... on ChineseCourseQuizHYDC {
        text
        explain
        audio
        gameId
      }
      ... on ChineseCourseQuizDCPX {
        text
        explain
        fixs
        audio
        gameId
      }
      ... on ChineseCourseQuizYDLJ {
        article
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on ChineseCourseQuizWXTK {
        article
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on ChineseCourseQuizTHXZ {
        article
        audio
        playTimes
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on ChineseCourseQuizXCTK {
        article
        extras
        parse {
          audio
          text
        }
        items {
          id
          answer
          parse {
            audio
            text
          }
        }
      }
      ... on ChineseCourseQuizBS {
        article
        title
        author
        hint
      }
      ... on ChineseCourseQuizTK {
        title
        text
        image
        explain
      }
    }
  }
}`;

export const COURSE_RESULT = `
mutation ($id: Int, $courseId: Int, $unitId: Int, $moduleId: Int, $type: String, $mode: String, $quizzes: String!, $spend: String, $seconds: Int, $isBacktrack: Int) {
  chineseCourseResult(id: $id, courseId: $courseId, unitId: $unitId, moduleId: $moduleId, type: $type, mode: $mode, quizzes: $quizzes, spend: $spend, seconds: $seconds, isBacktrack: $isBacktrack) {
    examId
    score
    progress
    isContinue
    bookReview
    message
    name
    schoolName
    bookName
    unitName
    wordCount
    time
  }
}`;
